import _cloneDeep from 'lodash.clonedeep'

import {
	ADD_ROOM,
	ADULT_AGE_SELECT,
	ADULTS_DECREASE,
	ADULTS_INCREASE,
	CANCEL,
	CHILD_AGE_SELECT,
	CHILD_DECREASE,
	CHILD_INCREASE,
	DONE,
	REMOVE_ROOM,
	SELECT_ROOM,
	UPDATE_COSTING,
} from '../../Constants'
const enableAddition = (totalChilds = 0, totalPax = 0, roomsCount = 0) => {
	return !(totalChilds >= 4 || roomsCount >= 6 || totalPax >= 9)
}

const isNullChild = childs => {
	return (childs || []).some(child => child === null)
}
const isAdultAgeFalsy = adultAges => {
	return (adultAges || []).some(age => Boolean(age) !== true)
}
export const getInitialState = costingInfo => {
	const totalAdults = costingInfo.reduce(
		(a, b) => a + (b['adultCount'] || 0),
		0,
	)
	const totalChilds = costingInfo.reduce(
		(a, b) => a + (b['childAges']['length'] || 0),
		0,
	)
	const roomsCount = costingInfo.length
	const totalPax = totalAdults + totalChilds
	return {
		costingInfo: _cloneDeep(costingInfo),
		roomsCount: roomsCount,
		totalAdults: totalAdults,
		totalChilds: totalChilds,
		activeRoom: 1,
		totalPax: totalPax,
		enableRoomAdition: enableAddition(totalChilds, roomsCount, totalPax),
		initialCostingInfo: _cloneDeep(costingInfo),
	}
}

const resetConfig = (costingInfo = []) => {
	costingInfo.map(info => {
		if (info.childAges.some(a => a === null)) {
			info.childAges = []
		}
	})
	return costingInfo
}

const getAdultCounterAlert = (currentRoom = {}) => {
	const { childAges = [], adultCount = 1 } = currentRoom
	if ((childAges || []).length + adultCount === 6) {
		return {
			errorResponse: 'Maximum of 6 people in a room',
			isError: false,
		}
	}
	return {
		errorResponse: '',
		isError: false,
	}
}

const getErrorResponse = (currentRoom = {}) => {
	const { childAges = [], adultCount = 1, adultAges } = currentRoom
	const infantCounts = (childAges || []).filter(child => child <= 2).length
	if (isNullChild(childAges)) {
		const errorObj = {
			errorResponse: 'Please enter the age details',
			isError: true,
		}
		if (adultAges && adultAges.length) {
			errorObj['enableRoomAdition'] = false
		}
		return errorObj
	} else if (adultCount < infantCounts) {
		return {
			errorResponse: 'Infant count should not be greater than adult count',
			isInfantExceed: true,
			isError: true,
		}
	} else if ((childAges || []).length + adultCount === 6) {
		return getAdultCounterAlert(currentRoom)
	} else if (adultAges && adultAges.length && isAdultAgeFalsy(adultAges)) {
		return {
			errorResponse: 'Please enter the age details',
			isError: true,
			enableRoomAdition: false,
		}
	} else {
		return {
			errorResponse: null,
			isError: false,
		}
	}
}

// const getAgeFieldError = (currentRoom = {}) => {
//   const { childAges = [], adultCount = 1,adultAges } = currentRoom;
//   if (isNullChild(childAges)) {
//     return {
//       errorResponse: 'Please enter the age details',
//       isError: true
//     };
//   } else if(adultAges && adultAges.length && isAdultAgeFalsy(adultAges)){
//     return {
//       errorResponse: 'Please enter the age details',
//       isError: true,
//       enableRoomAdition: false
//     };
//   }else {
//     return {
//       errorResponse: null,
//       isError: false
//     };
//   }
// }

const PAXState = (state, action) => {
	switch (action.type) {
		case ADD_ROOM:
			if (action.payload) {
				let {
					costingInfo,
					roomsCount,
					totalAdults,
					totalChilds,
					totalPax,
					activeRoom,
				} = state
				const errorResponse = getErrorResponse(costingInfo[activeRoom - 1])
				if (errorResponse.isError) {
					return {
						...state,
						...errorResponse,
					}
				}
				costingInfo = [...costingInfo, action.payload]
				roomsCount += 1
				totalAdults += 1
				totalPax += 1
				return {
					...state,
					...errorResponse,
					costingInfo,
					roomsCount,
					totalAdults,
					totalPax,
					activeRoom: costingInfo.length,
					enableRoomAdition: enableAddition(totalChilds, totalPax, roomsCount),
					...getAdultCounterAlert(costingInfo[costingInfo.length - 1]),
				}
			}
			return state
		case REMOVE_ROOM:
			if (action.payload) {
				let {
					costingInfo,
					roomsCount,
					totalAdults,
					totalChilds,
					totalPax,
					activeRoom,
				} = state
				const currentRoom = costingInfo[activeRoom - 1]
				const { adultCount = 1, childAges = [] } = currentRoom
				roomsCount -= 1
				totalAdults -= adultCount
				totalChilds -= (childAges || []).length
				totalPax -= adultCount + (childAges || []).length
				costingInfo.splice(activeRoom - 1, 1)
				const errorResponse = getErrorResponse(costingInfo[0])
				return {
					...state,
					...errorResponse,
					costingInfo,
					roomsCount,
					totalAdults,
					totalChilds,
					totalPax,
					activeRoom: 1,
					enableRoomAdition: enableAddition(totalChilds, totalPax, roomsCount),
				}
			}
			return state
		case SELECT_ROOM:
			if (action.payload) {
				let { costingInfo, activeRoom } = state
				const errorResponse = getErrorResponse(costingInfo[activeRoom - 1])
				if (errorResponse.isError) {
					return {
						...state,
						...errorResponse,
					}
				}
				return {
					...state,
					...action.payload,
					...errorResponse,
					...getAdultCounterAlert(costingInfo[action.payload.activeRoom - 1]),
				}
			}
			return state
		case ADULTS_INCREASE:
			if (action.payload) {
				let {
					costingInfo,
					activeRoom,
					totalAdults,
					totalPax,
					enableRoomAdition,
					totalChilds,
					roomsCount,
				} = state
				totalAdults += 1
				totalPax += 1
				const tmpCost = [...costingInfo]
				tmpCost[activeRoom - 1].adultCount += 1
				enableRoomAdition = enableAddition(totalChilds, totalPax, roomsCount)
				return {
					...state,
					costingInfo: tmpCost,
					totalAdults,
					totalPax,
					enableRoomAdition,
					...getAdultCounterAlert(costingInfo[activeRoom - 1]),
				}
			}
			return state
		case ADULTS_DECREASE:
			if (action.payload) {
				let {
					costingInfo,
					activeRoom,
					totalAdults,
					totalPax,
					enableRoomAdition,
					totalChilds,
					roomsCount,
				} = state
				totalAdults -= 1
				totalPax -= 1
				const tmpCost = [...costingInfo]
				tmpCost[activeRoom - 1].adultCount -= 1
				enableRoomAdition = enableAddition(totalChilds, totalPax, roomsCount)
				return {
					...state,
					costingInfo: tmpCost,
					totalAdults,
					totalPax,
					enableRoomAdition,
					...getAdultCounterAlert(costingInfo[activeRoom - 1]),
				}
			}
			return state
		case CHILD_INCREASE:
			if (action.payload) {
				let {
					costingInfo,
					activeRoom,
					totalAdults,
					totalPax,
					enableRoomAdition,
					totalChilds,
					roomsCount,
				} = state
				totalPax += 1
				totalChilds += 1
				costingInfo[activeRoom - 1].childAges.push(null)
				enableRoomAdition = enableAddition(totalChilds, totalPax, roomsCount)
				return {
					...state,
					costingInfo,
					totalAdults,
					totalPax,
					enableRoomAdition,
					...getAdultCounterAlert(costingInfo[activeRoom - 1]),
				}
			}
			return state
		case CHILD_DECREASE:
			if (action.payload) {
				let {
					costingInfo,
					activeRoom,
					totalAdults,
					totalPax,
					enableRoomAdition,
					totalChilds,
					roomsCount,
				} = state
				totalPax -= 1
				totalChilds -= 1
				costingInfo[activeRoom - 1].childAges.pop()
				enableRoomAdition = enableAddition(totalChilds, totalPax, roomsCount)
				return {
					...state,
					costingInfo,
					totalAdults,
					totalPax,
					enableRoomAdition,
					...getAdultCounterAlert(costingInfo[activeRoom - 1]),
				}
			}
			return state
		case CHILD_AGE_SELECT:
			if (action.payload) {
				const { costingInfo, activeRoom, errorResponse } = state
				const { childIndex, age } = action.payload
				costingInfo[activeRoom - 1].childAges[childIndex] = age
				if (errorResponse) {
					const errorResponse = getErrorResponse(costingInfo[activeRoom - 1])
					return {
						...state,
						...errorResponse,
						...costingInfo,
					}
				}
				return { ...state, costingInfo }
			}
			return state
		case ADULT_AGE_SELECT:
			if (action.payload) {
				const { costingInfo, activeRoom, errorResponse } = state
				const { adultIndex, age } = action.payload
				costingInfo[activeRoom - 1].adultAges[adultIndex] = age
				if (errorResponse) {
					const errorResponse = getErrorResponse(costingInfo[activeRoom - 1])
					return {
						...state,
						...errorResponse,
						...costingInfo,
					}
				}
				return { ...state, costingInfo }
			}
			return state
		case UPDATE_COSTING: {
			return {
				...getInitialState(_cloneDeep(action.payload)),
			}
		}
		case CANCEL: {
			if (action.payload) {
				const { initialCostingInfo } = state
				action.payload.triggerAction(
					_cloneDeep(resetConfig(initialCostingInfo)),
				)
				return state
			}
			return state
		}
		case DONE: {
			const { triggerAction, showOnlyAgeField } = action.payload
			let { costingInfo, activeRoom, roomsCount } = state
			const errorResponse = getErrorResponse(costingInfo[activeRoom - 1])
			errorResponse['enableRoomAdition'] = false
			if (errorResponse.isError) {
				return {
					...state,
					...errorResponse,
				}
			} else if (showOnlyAgeField && activeRoom < roomsCount) {
				/**
				 * Make sure each room has age field entered
				 * since age fields for each room rendered based on room config details without using 'Add room' button.
				 */
				activeRoom++
				const errorResponse = getErrorResponse(costingInfo[activeRoom - 1])
				errorResponse['enableRoomAdition'] = false
				if (errorResponse.isError) {
					return {
						...state,
						activeRoom,
						...errorResponse,
					}
				}
			}
			triggerAction()
			return state
		}
		default:
			return state
	}
}

export default PAXState
